import { render, staticRenderFns } from "./AllergiesAdd.vue?vue&type=template&id=4971fd7c"
import script from "./AllergiesAdd.vue?vue&type=script&lang=js"
export * from "./AllergiesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports